// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__MpCAl","error":"Form_error__tJVes","buttonAndLoader":"Form_buttonAndLoader__oCwCw"};